import { DEFAULT_STOREFRONT } from "../../cart/constants"

import { useCallback } from "react"

export interface PurchasableItemBase {
  storyblokUuid: string
  storefront: string
}

export interface PurchasableProduct extends PurchasableItemBase {
  type: "product"
  sku: string
}

export interface PurchasableBundle extends PurchasableItemBase {
  type: "bundle"
  bundleCode: string
}

export type PurchasableItem = PurchasableProduct | PurchasableBundle

export type SelectedPurchasableItem = {
  purchasableItem: PurchasableItem
  quantity: number
}

export const isPurchasableProduct = (
  PurchasableItem: PurchasableItem
): PurchasableItem is PurchasableProduct => {
  return PurchasableItem.type === "product"
}

export const isPurchasableBundle = (
  PurchasableItem: PurchasableItem
): PurchasableItem is PurchasableBundle => {
  return PurchasableItem.type === "bundle"
}

//TODO this mapping can be made unneccessary by making AddToCartButton work directly with consolidatedBundle | consolidatedProduct
export const useGetPurchasableItem = () => {
  //Create an object containing the fields needed on AddToCartButton for handling product | bundle calls
  const getPurchasableItem = useCallback(
    (
      storyblokUuid: string,
      object: Storyblok.ProductConfig | Storyblok.BundleConfig
    ): PurchasableItem => {
      if (object.component === "product") {
        const product = object as Storyblok.ProductConfig
        return {
          storyblokUuid,
          sku: product?.sku,
          type: "product",
          storefront: product.storefront ?? DEFAULT_STOREFRONT,
        }
      } else {
        // Assume this is a bundle object
        const bundle = object as Storyblok.BundleConfig
        return {
          storyblokUuid,
          bundleCode: bundle?.code,
          type: "bundle",
          storefront: bundle.storefront ?? DEFAULT_STOREFRONT,
        }
      }
    },
    []
  )

  return getPurchasableItem
}
